<app-point-form></app-point-form>
<!-- <idel-add-action-form></idel-add-action-form> -->